const COST_OF_STAY_FEE_TYPES = {
  hotel: '5'
};

export default COST_OF_STAY_FEE_TYPES;
